import AuthService from '@/services/AuthService'
import router from '../../router'

export default {
  state: {
    user: parseUser()
  },
  getters: {
    user: state => state.user,
    isAuthenticated: state => !!state.user,
    // This is also enforced on the server side, it's just used to try and keep non-admin from the console
    hasWritePermission: state => isInGroup(state, 'Campus Maps - Admins')
  },
  mutations: {
    setUser (state, data) {
      if (!data) {
        localStorage.removeItem('user')
      } else {
        localStorage.setItem('user', JSON.stringify(data))
        state.user = data
      }
    }
  },
  actions: {
    async login ({ commit }, redirect) {
      router.push({
        path: '/login',
        query: { redirect: redirect }
      })
    },
    logout ({ commit }) {
      commit('setUser', null)
      router.push({
        path: '/logout'
      })
    },
    async loadUser ({ commit, dispatch }, redirect) {
      const response = await AuthService.getUser()

      if (response.data.success === false) {
        dispatch('login', redirect)
        return
      }

      commit('setUser', response.data)
    }
  }
}

function parseUser () {
  try {
    return JSON.parse(localStorage.getItem('user'))
  } catch (e) {
    return null
  }
}

function isInGroup (state, group) {
  const groups = {
    'Campus Maps - Admins': 'd67c7ec5-de0d-4c5a-aee8-9c86bfca7b4f',
    'Auto: All Students': 'da2999c7-16d9-416a-b743-5d88f1b16532',
    'Auto: All Faculty and Staff': '855d4ef9-449b-430e-8f71-85b76ceee21d'
  }

  const activeGroup = groups[group]
  if (!activeGroup) return false

  return state.user && state.user.groups && state.user.groups.includes(activeGroup)
}
